var map = {
	"./LogoDropship.png": "7d36",
	"./Users-Settings.png": "b633",
	"./accout.png": "b306",
	"./addshipment.png": "17c2",
	"./bg-forgot.png": "c3ee",
	"./bg_sendmail.png": "438a",
	"./bookingSuccess.png": "6042",
	"./bookingerror.png": "4965",
	"./cardboard-boxes.png": "1b40",
	"./confSuccess.png": "0d59",
	"./confrim.png": "0fea",
	"./confrim2.png": "d620",
	"./lock-mail.png": "a35c",
	"./lock.png": "4f99",
	"./logoOBB.png": "ad7a",
	"./mail_resend.png": "7de3",
	"./new-items.png": "50f1",
	"./no.png": "4fb4",
	"./other.png": "836b",
	"./person-forgot.png": "1b78",
	"./person-login.png": "152e",
	"./profile-admin.png": "3902",
	"./resend-email.png": "a24a",
	"./send_fail.png": "4a60",
	"./send_success.png": "aeee",
	"./setting.png": "abf7",
	"./settings.png": "9d6a",
	"./shadow.png": "c2aa",
	"./shipping_bus.png": "67a0",
	"./shopping.png": "bd25",
	"./success.png": "46e6",
	"./user-profile.png": "5198",
	"./wallet.png": "a3e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";